<template>
  <div class="NavBarSettings">
    <span class="NavBarSettings__title">
      Settings
    </span>
  </div>
</template>

<script>
export default {
  name: 'NavBarSettings'
}
</script>

<style lang="scss">
@import 'NavBarSettings';
</style>
